
/* styles */
require("!!../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-bf666cf8&scoped=true!../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./overlay.vue")

var Component = require("!../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./overlay.vue"),
  /* template */
  require("!!../../../../node_modules/vue-loader/lib/template-compiler?id=data-v-bf666cf8!../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./overlay.vue"),
  /* scopeId */
  "data-v-bf666cf8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/comps/internal/popup/overlay.vue
// module id = 750
// module chunks = 34